import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
    display:flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
    width:100%;
    height:80%;
`;

const InformationContainer = styled.div`
    display:flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    box-shadow: 0px 0px 20px #ccc;
    position: relative;
    margin-top: 15px;
    padding: 20px 40px;
`;

const InformationImportGuestsContainer = styled.div`
    display:flex;
    align-items: center;
    justify-content:center;
    width: auto;
    height: auto;
    position: relative;
    padding: 15px;

    & > ul {
      display:inherit;
      flex-direction: column;
      list-style-type: none;
      padding: 0;
      margin: 0;
      position: relative;

      & > li {
        display:inherit;
        align-items: center;
        justify-content:space-between;
        width: 100%;
        height: 50px;
        min-height: 50px;
        position: relative;

         & > span {
          display:inherit;
          align-items: center;
          justify-content:flex-start;
          height: 100%;
          width: 100%;
          min-width: 100px;
          max-width:150px;
          padding: 0 15px;

          & > p {
            white-space: nowrap; 
            overflow: hidden;
            text-overflow: ellipsis;
          }

          & > img {
            width: auto;
            height: 70%;
            position: relative;
          }
        }

        & > span:not(:last-child) {
          border-right: 1px solid #EEEEEE;
        }
      }

      & > li:last-child {
        border-top: 1px solid #EEEEEE;
         & > span:first-child  > p:first-child {
          font-weight: bold;
        }
      }

      & > li:first-child {
        border-bottom: 1px solid #EEEEEE;
        & > span {
          font-weight: bold;
          background: #ecf2f8;
          border-right: 1px solid #FFFFFF;
        }
      }
      & > li:nth-child(odd) {
        background: rgba(245, 245, 245, 0.5);
        & > span:not(:last-child) {
          border-right: 1px solid #FFFFFF;
        }
      }
    }
`;

const InformationButtonContainer = styled.div`
    display:flex;
    align-items: center;
    justify-content:center;
    width: 100%;
`;

const occurrenceInArray = (array, from) => {
  const result = {};
  if (array instanceof Array) {
    array.forEach((v, i) => {
      if (!result[v]) {
        result[v] = [i];
      } else {
        result[v].push(i);
      }
    });
  }
  const formattedResult = Object.keys(result).map(key => ({ [from]: { name: key, result: result[key] } }));
  return formattedResult;
};

const mergeArray = array => array.reduce((a, b) => a.concat(b), []);

const InformationImportGuestsContent = (
  formattedFile,
  importedFileTitleRow,
  importFileDoneGuestsText,
  importFileDoneGuestToImportText,
  importFileDoneGuestTotalText,
  ) => {
  const ageIndex = importedFileTitleRow.findIndex(row => row && row.name === 'age');
  if (ageIndex !== -1) {
    const getAges = formattedFile.map(row => row && Object.values(row[ageIndex]).indexOf('value') && row[ageIndex].value).filter(a => a !== undefined);
    const countGuestAges = occurrenceInArray(getAges, 'guests');
    const combinedGuestAndCabin = countGuestAges.map((x, i) => [x, [i]]);
    return (
      <ul key="done">
        <li>
          <span><p>{importFileDoneGuestsText}</p></span>
          <span><p>{importFileDoneGuestToImportText}</p></span>
        </li>
        {
          combinedGuestAndCabin.map((item) => {
            const ageGroup = (item[0] && item[0].guests && item[0].guests.name) || 0;
            const ageCount = (item[0] && item[0].guests && item[0].guests.result.length) || 0;
            return (
              <li key={ageGroup}>
                <span><p>{ageGroup}</p></span>
                <span><p>{ageCount}</p></span>
              </li>
            );
          })
        }
        <li>
          <span><p>{importFileDoneGuestTotalText}</p></span>
          <span><p>{formattedFile.length - 1}</p></span>
        </li>
      </ul>
    );
  }
  return null;
};

const InformationImportGuestsCabinContent = (
  formattedFile,
  personsLinkedToCabin,
  importedFileTitleRow,
  cabinsOut,
  cabinsHome,
  importFileDoneGuestsText,
  importFileDoneGuestToImportText,
  importFileDoneCabinOutText,
  importFileDoneCabinHomeText,
  importFileDoneGuestTotalText,
  ) => {
  const allGuestIdsInCabinOut = mergeArray(personsLinkedToCabin.filter(cabin => cabinsOut.includes(cabin.cabin)).map(row => row.guests && row.guests.id));
  const allGuestIdsInCabinHome = mergeArray(personsLinkedToCabin.filter(cabin => cabinsHome.includes(cabin.cabin)).map(row => row.guests && row.guests.id));
  const ageIndex = importedFileTitleRow.findIndex(row => row && row.name === 'age');
  if (ageIndex !== -1) {
    const getAges = formattedFile.map(row => row && Object.values(row[ageIndex]).indexOf('value') && row[ageIndex].value).filter(a => a !== undefined);
    const getAgesInCabinsOut = formattedFile.map(row => row && Object.values(row[ageIndex]).indexOf('value') && allGuestIdsInCabinOut.includes(row.id) && row[ageIndex].value).filter(a => a !== false);
    const getAgesInCabinsHome = formattedFile.map(row => row && Object.values(row[ageIndex]).indexOf('value') && allGuestIdsInCabinHome.includes(row.id) && row[ageIndex].value).filter(a => a !== false);
    const countGuestAges = occurrenceInArray(getAges, 'guests');
    const countAgesInCabinOut = occurrenceInArray(getAgesInCabinsOut, 'cabinsOut');
    const countAgesInCabinHome = occurrenceInArray(getAgesInCabinsHome, 'cabinsHome');
    const combinedGuestAndCabin = countGuestAges.map((x, i) => [x, countAgesInCabinOut[i], countAgesInCabinHome[i]]);
    return (
      <ul key="done">
        <li>
          <span><p>{importFileDoneGuestsText}</p></span>
          <span><p>{importFileDoneGuestToImportText}</p></span>
          <span><p>{importFileDoneCabinOutText}</p></span>
          <span><p>{importFileDoneCabinHomeText}</p></span>
        </li>
        {
          combinedGuestAndCabin.map((item) => {
            const ageGroup = (item[0] && item[0].guests && item[0].guests.name) || 0;
            const ageCount = (item[0] && item[0].guests && item[0].guests.result.length) || 0;
            const cabinCountOut = (item[1] && item[1].cabinsOut && item[1].cabinsOut.result.length) || 0;
            const cabinCountHome = (item[2] && item[2].cabinsHome && item[2].cabinsHome.result.length) || 0;
            return (
              <li key={ageGroup}>
                <span><p>{ageGroup}</p></span>
                <span><p>{ageCount}</p></span>
                <span><p>{cabinCountOut}</p></span>
                <span><p>{cabinCountHome}</p></span>
              </li>
            );
          })
        }
        <li>
          <span><p>{importFileDoneGuestTotalText}</p></span>
          <span><p>{formattedFile.length - 1}</p></span>
          <span><p>{allGuestIdsInCabinOut.length}</p></span>
          <span><p>{allGuestIdsInCabinHome.length}</p></span>
        </li>
      </ul>
    );
  }
  return null;
};


const Done = ({
    buttonTitle,
    onDoneImportFileClick,
    personsLinkedToCabin,
    formattedFile,
    importedFileTitleRow,
    cabinsOut,
    cabinsHome,
    isCabinChoosenInDropdown,
    importFileDoneGuestsText,
    importFileDoneGuestToImportText,
    importFileDoneCabinOutText,
    importFileDoneCabinHomeText,
    importFileDoneGuestTotalText,
}) => (
  <Container>
    <InformationContainer>
      <InformationImportGuestsContainer>
        {personsLinkedToCabin.length > 0 && formattedFile.length && isCabinChoosenInDropdown
        ? InformationImportGuestsCabinContent(
          formattedFile,
          personsLinkedToCabin,
          importedFileTitleRow,
          cabinsOut,
          cabinsHome,
          importFileDoneGuestsText,
          importFileDoneGuestToImportText,
          importFileDoneCabinOutText,
          importFileDoneCabinHomeText,
          importFileDoneGuestTotalText,
          )
        : InformationImportGuestsContent(
          formattedFile,
          importedFileTitleRow,
          importFileDoneGuestsText,
          importFileDoneGuestToImportText,
          importFileDoneGuestTotalText,
          )
        }
      </InformationImportGuestsContainer>
      <InformationButtonContainer>
        <button
          className="import-file-done-button"
          onClick={() => onDoneImportFileClick()}
        >
          {buttonTitle}
        </button>
      </InformationButtonContainer>
    </InformationContainer>
  </Container>
);

Done.propTypes = {
  buttonTitle: PropTypes.string,
  onDoneImportFileClick: PropTypes.func,
  personsLinkedToCabin: PropTypes.array,
  formattedFile: PropTypes.array,
  importedFileTitleRow: PropTypes.array,
  cabinsOut: PropTypes.array,
  cabinsHome: PropTypes.array,
  isCabinChoosenInDropdown: PropTypes.bool,
  importFileDoneGuestsText: PropTypes.string,
  importFileDoneGuestToImportText: PropTypes.string,
  importFileDoneCabinOutText: PropTypes.string,
  importFileDoneCabinHomeText: PropTypes.string,
  importFileDoneGuestTotalText: PropTypes.string,
};

export default Done;



// WEBPACK FOOTER //
// ./src/components/organisms/ImportFile/steps/done.js